/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Filetoggle_Downloadable3Inputs */

const en_coinvestments_dataroom_filetoggle_downloadable3 = /** @type {(inputs: Coinvestments_Dataroom_Filetoggle_Downloadable3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloadable`)
};

/**
* | output |
* | --- |
* | "Downloadable" |
*
* @param {Coinvestments_Dataroom_Filetoggle_Downloadable3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_filetoggle_downloadable3 = /** @type {((inputs?: Coinvestments_Dataroom_Filetoggle_Downloadable3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Filetoggle_Downloadable3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_filetoggle_downloadable3(inputs)
});
export { coinvestments_dataroom_filetoggle_downloadable3 as "coInvestments_dataRoom_fileToggle_downloadable" }